import { AppRouteProps } from "@harea/component";
import React from "react";
import { TaxBracketsCreateRoutes } from "./views/create/TaxBracketsCreateRoutes";

const TaxBracketsList = React.lazy(() => import("./containers/TaxBracketsList"));

export const TaxBracketsRoutes: Array<AppRouteProps> = [
    {
        path: "tax-brackets",
        title: "Harea.UserOrganisation.TaxBracket.List.Title",
        element: <TaxBracketsList />,
        roles: ["SUPER_ADMIN", "ADMIN", "DIRECTOR_HR"],
        children: [
            ...TaxBracketsCreateRoutes
        ]
    },
];